export const historyKeys = {
  all: () => ["bookingHistory"],
  ofBooking: (bookingId: number, isExternalUsage?: boolean) => [
    ...historyKeys.all(),
    bookingId,
    ...(isExternalUsage !== undefined ? [isExternalUsage] : [])
  ]
};
